import { connect } from "react-redux";
import { sceneSlice } from "../../store/sceneSlice";
import { sessionSlice } from "../../store/sessionSlice";
import LlmModule from "../components/LlmModule";

const mapStateToProps = (state) => {
  return {
    pdb: state.scene.pdb,
    isActive: state.session.isLlmActive,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onMoleculeScale: (type) => {
      dispatch(sceneSlice.actions.emitMoleculeScaleUpdate({ type }));
    },
    onUpdateRates: (type) => {
      dispatch(sceneSlice.actions.emitUpdateRatesChange({ type }));
    },
    onTemperatureChange: (deltaT) => {
      dispatch(sceneSlice.actions.emitTemperatureChange({ deltaT }));
    },
    onTemperatureSet: (newT) => {
      dispatch(sceneSlice.actions.emitTemperatureSet({ newT }));
    },
    onSetAtomRadiusFactors: (applyVDW) => {
      dispatch(sceneSlice.actions.emitSetAtomRadiusFactors({ applyVDW }));
    },
    onSetAtomColors: (applyColor) => {
      dispatch(sceneSlice.actions.emitSetAtomColors({ applyColor }));
    },
    onSetStickRadius: (applyRadius) => {
      dispatch(sceneSlice.actions.emitSetStickRadius({ applyRadius }));
    },
    onSetSelection: (toSelect) => {
      dispatch(sceneSlice.actions.emitSetSelection({ toSelect }));
    },
    onStartSim: () => {
      dispatch(sessionSlice.actions.emitStartSim());
    },
    onStopSim: () => {
      dispatch(sessionSlice.actions.emitStopSim());
    },
    onMolRotationSetByValue: (newMolRotations) => {
      console.log("origin 2")
      dispatch(sessionSlice.actions.emitSetMolRotationByValue({ newMolRotations }));
    },
    onMolRotationChange: (newMolRotations) => {
      console.log("origin 2")
      dispatch(sessionSlice.actions.emitSetMolRotationChange({ newMolRotations }));
    },
    onWritePDB: () => {
      dispatch(sessionSlice.actions.emitWritePDB());
    },
    onDisplayToast: (message) => {
      dispatch(sessionSlice.actions.displayToast({ message }));
    },
    onFocus: () => {
      dispatch(sessionSlice.actions.isTyping({ typing: true }));
    },
    onBlur: () => {
      dispatch(sessionSlice.actions.isTyping({ typing: false }));
    },
    onToggleLlmActive: (isActive) => {
      dispatch(sessionSlice.actions.toggleLlmActive({ isActive }));
    },
  };
};

export const LlmContainer = connect(mapStateToProps, mapDispatchToProps)(LlmModule);
